import React from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ItemAssignmentForm} from 'src/app/item-tracker/ItemAssignmentForm';
import {itemAssignmentDocumentTitle} from 'src/app/item-tracker/itemAssignmentHelpers';

const ItemAssignmentClonePage: React.FC = () => {
  useSetDocumentTitle(`${itemAssignmentDocumentTitle} - Clone`);

  const {definitionId, id} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      {id !== undefined && (
        <ItemAssignmentForm
          definitionId={Number(definitionId)}
          id={Number(id)}
          mode="clone"
          enableEdit={true}
          enableTransitions={false}
        />
      )}
    </ContentWrapper>
  );
};

export default ItemAssignmentClonePage;

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ItemAssignmentClone(':definitionId', ':id'),
  element: <ItemAssignmentClonePage />,
  isPrivate: true,
  module: ModuleEnum.ItemTrackerAssignments,
  operation: PermissionOperationEnum.Create,
});
